import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: 'calc(100vh - 70px)',
      marginTop: 80,
      marginBottom: 70
    }
  },
  boxtitle: {
    width: '90%',
    display: 'flex',
    marginLeft: '5%',
    color: '#4B4952',
    paddingTop: '0.5rem'
  },
  icon: {
    fontSize: '2.2em',
    color: '#028B7E'
  },
  title: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '0.5rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  subtitle: {
    fontSize: '0.9rem',
    marginLeft: 8,
    fontWeight: 'bold'
  },

  typography: {
    fontSize: '1em'
  },
  boxTable: {
    width: '90%',
    marginLeft: '5%',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    marginTop: '1rem'
  }
}))

export default useStyles
